import Colors from '../../utils/color';

/**
 * HITL-1614 / HITL-1615 — the geometry shared by the two cart-transfer icons.
 *
 * A 20px circle centred ON a card's border, so it costs the column 6px of width
 * instead of the 26px a full-height rail would. The `::before` `inset: -7px`
 * grows the hit target back to a comfortable 34px without growing the visible
 * circle.
 *
 * Shared rather than copied so the copy control (left border, pointing into My
 * Cart) and the promote control (right border, pointing into the order) cannot
 * drift apart — the mirror only reads as a mirror if the two are identical but
 * for the side.
 *
 * `sx` rather than `makeStyles`: emotion hashes on content, so a brand-new
 * element cannot renumber an existing one. A `makeStyles` rule would move JSS's
 * global counter and churn class names in unrelated snapshots.
 */
export const borderCircleSx = (side: 'left' | 'right') => ({
  position: 'absolute' as const,
  [side]: 0,
  top: '50%',
  transform: side === 'left' ? 'translate(-50%, -50%)' : 'translate(50%, -50%)',
  zIndex: 2,
  width: 20,
  height: 20,
  padding: 0,
  backgroundColor: Colors.white,
  border: `1px solid ${Colors.alto}`,
  color: Colors.readBack,
  '&::before': {
    content: '""',
    position: 'absolute',
    inset: -7,
  },
  '&:hover': {
    backgroundColor: Colors.readBack,
    color: Colors.white,
    borderColor: Colors.readBack,
  },
  '& .MuiSvgIcon-root': { fontSize: '0.85rem' },
});

/**
 * The positioned ancestor the circle hangs off. A module-level frozen inline
 * style, applied only when a control is actually rendered — so the flag-off tree
 * is unchanged down to the node, and no `makeStyles` rule is added to a
 * snapshotted sheet.
 */
export const BORDER_CIRCLE_ANCHOR_STYLE: React.CSSProperties = Object.freeze({
  position: 'relative',
});
